import {
  HighlightProps,
  RectangleHighlight,
} from 'components/Images/Highlights/HighlightTypes'
import { useRef, useState } from 'react'
import {
  handleSvgHighlightClicked,
  handleSvgHighlightDoubleClicked,
} from './handleSvgHighlightClicked'
import { HighlightTooltip } from './HighlightTooltip'
import { useHighlightColor } from './useHighlightColor'

export const RectangleHightlight = (
  props: HighlightProps<RectangleHighlight>,
) => {
  const { fillColor, opacity, classNames, activeStrokeColor } =
    useHighlightColor({
      isActiveCheckListFeature: props.isActiveCheckListFeature,
      isDoneCheckListFeature: props.isDoneCheckListFeature,
      isCheckListFeature: props.isCheckListFeature,
    })

  const [open, setOpen] = useState(false)

  const clickStart = useRef<{ x: number; y: number } | null>(null)

  const ignore = false
  if (ignore) {
    return null
  }

  return (
    <HighlightTooltip
      {...props}
      open={open}
      setOpen={setOpen}
      enableHoverListener
    >
      <rect
        x={props.x1 - 4}
        y={props.y1 - 4}
        width={8 + props.x2 - props.x1}
        height={8 + props.y2 - props.y1}
        fill={fillColor.main}
        style={{
          opacity: 0.5,
          cursor: 'pointer',
        }}
        stroke={
          props.isActiveCheckListFeature ? activeStrokeColor : fillColor.dark
        }
        strokeWidth={6}
        strokeOpacity={props.isActiveCheckListFeature ? 1 : opacity}
        onMouseDown={(e) => {
          if (e.button !== 0) return //only left click

          e.stopPropagation()
          e.preventDefault()
          clickStart.current = { x: e.clientX, y: e.clientY }
        }}
        onMouseUp={(e) => {
          if (e.button !== 0) return //only left click
          e.stopPropagation()
          e.preventDefault()

          const clickEnd = { x: e.clientX, y: e.clientY }
          const ratioX = clickEnd.x / clickStart.current?.x || clickEnd.x
          const ratioY = clickEnd.y / clickStart.current?.y || clickEnd.y

          if (Math.abs(ratioX - 1) < 0.01 && Math.abs(ratioY - 1) < 0.01) {
            handleSvgHighlightClicked(props.id, props.pdfPage, props.pdfFeature)
          } else {
            console.info('mouse moved, not triggering click')
          }

          clickStart.current = null
        }}
        onDoubleClick={(e) => {
          e.preventDefault()
          e.stopPropagation()

          handleSvgHighlightDoubleClicked(props.pdfFeature)
        }}
        strokeDasharray={props.isActiveCheckListFeature ? '16 10' : '0'}
        strokeDashoffset={0}
        filter={props.isActiveCheckListFeature ? 'url(#glow)' : ''}
      >
        {props.isActiveCheckListFeature && (
          <>
            <animate
              attributeName="stroke-dashoffset"
              from="0"
              to="-80"
              dur="2s"
              repeatCount={'indefinite'}
            />
          </>
        )}
      </rect>
    </HighlightTooltip>
  )
}
